/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-06 12:03:11
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface PSCRecordListParams {
  current?: any
  size?: any
  handleDateEnd?:any
  handleDateStart?:any
}

export function getPSCRecordList(
  params: PSCRecordListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspcustomerservice/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}

// 详情
export function getTPSCRecordDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspcustomerservice/detail`,
    method: 'GET',
    params
  }
}


// 保存编辑
export interface SubmitParams {
  id?: any
  address	?: any
  contactPhone?: any
  customerName?: any
  handleDate?:any
  handleResult?: any
  handleSuggestion?: any
  handlerId?: any
  handlerName?: any
  content?:any
}

export function getPSCRecordSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspcustomerservice/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspcustomerservice/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}


export function getPSCRecordListExport(
  params: PSCRecordListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspcustomerservice/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params
  }
}